import moment from 'moment'

import { observer } from 'mobx-react'

import DayPicker from 'modules/core/components/DayPicker'
import MonthPicker from 'modules/core/components/MonthPicker'
import { dateToString } from 'modules/core/lib/dates'

import { MONTHLY } from 'modules/payroll_bundle/store/models/Policy'

interface Props {
  label: string
  periodicity: string | undefined
  enableDay: (date: Date | moment.Moment) => boolean
  onChange: (value: string) => void
  startOnValue: string
}

const StartsOnDatePicker = ({ label, periodicity, enableDay, onChange, startOnValue }: Props) => {
  if (periodicity === MONTHLY) {
    if (!startOnValue) {
      onChange(moment().startOf('month').format('YYYY-MM-DD'))
    }

    return (
      <MonthPicker
        label={label}
        value={dateToString(moment(startOnValue), 'ui')}
        onChange={(value) => {
          onChange(moment(value).startOf('month').format('YYYY-MM-DD'))
        }}
      />
    )
  }

  return (
    <DayPicker
      valueFormat="backend"
      mandatory
      enableDay={enableDay}
      label={label}
      value={startOnValue}
      onChange={(value) => {
        onChange(value)
      }}
    />
  )
}

export default observer(StartsOnDatePicker)
